import ReactDOM from "react-dom/client";

import { AuthProvider } from "./frontend/context/auth";

import App from "./frontend/App";

//CSS de terceiros
import "bootstrap/dist/css/bootstrap.min.css";
import "rc-pagination/assets/index.css";
import "tippy.js/dist/tippy.css";

//CSS da aplicação
import "./frontend/css/root.css";
import "./frontend/css/app.css";
import "./frontend/css/layout.css";
import "./frontend/css/seletores.css";

//CSS do tema customizado
import "./frontend/css/tema_siig.css";
import "./frontend/css/tema_adm_system.css";

// import { setupImportErrorHandler } from "./frontend/utils/importErrorHandler";

// setupImportErrorHandler();

//Tela aberta antes de uma publicação: ao não encontrar o arquivo de uma tela, recarrega para buscar a versão nova
import { fn_registrarTratamentoErroImport } from "./frontend/utils/versao";

fn_registrarTratamentoErroImport();

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <AuthProvider>
    <App />
  </AuthProvider>,
);
